import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//Material
import { MaterialModule } from './material/material.module';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { CodeInputModule } from 'angular-code-input';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        CodeInputModule,
     ],
    declarations: [
        ConfirmComponent,
    ],
    exports: [
        ConfirmComponent,
        MaterialModule,
        CodeInputModule,
    ]
})
export class SharedModule {}
